.indicator {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9375rem;
}

/* Quadratisch, ohne Rundung und ohne Pulsieren – passend zur Formensprache von byliox.dev. */
.mark {
  width: 10px;
  height: 10px;
  flex: none;
  border: 1px solid transparent;
}

.ok {
  background: var(--status-ok);
}

.busy {
  background: var(--status-busy);
}

.ringing {
  background: var(--accent);
}

.off {
  border-color: var(--text-muted);
}
